import omit from 'lodash/omit';
import isNumber from 'lodash/isNumber';
import TextField from '@mui/material/TextField';
import CustomInput from './CustomInput';

const handleChange = ({onChange, step}) => e => {
  step === 1
  ? onChange({target: {value: parseInt(e.target.value, 10)}})
  : onChange(e)
};

const CustomNumberField = props => {
  const {step, onChange} = props;
  const InputProps = {
    inputProps: {
      type: 'number',
      min: isNumber(props.min) ? props.min : null,
      max: isNumber(props.max) ? props.max : null,
      step: props.step || null,
      maxlength: props.maxlength || props.maxLength || null,
      fullWidth: props.fullWidth
    }
  };
  return (
    <CustomInput {...omit(props, 'children')}>
      <TextField
        type='number'
        style={{
          ...(props.style || {}),
          backgroundColor: 'white',
        }}
        sx={{...(props.sx || {})}}
        InputProps={InputProps}
        {...omit(props, 'helperText', 'label', 'style', 'sx')}
        onChange={handleChange({onChange, step})}
      />
    </CustomInput>
  );
};

export default CustomNumberField;
